import { render } from "./ProfileView.vue?vue&type=template&id=1ff9a706"
import script from "./profile-view-component.ts?vue&type=script&lang=js&external"
export * from "./profile-view-component.ts?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__